import { useEffect, useState } from 'react'

const useDynamicWindowHeightHook = () => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

  const handleResize = () => {
    setWindowHeight(window.innerHeight)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      // cleanup
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    windowHeight,
  }
}

export default useDynamicWindowHeightHook
